'use strict';

import {listFormError, printResponse, resetForm} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnSaveCustomerNumber = function () {

    var element = '#form-save-customer-number';

    if (!element_exists(element)) return false;

    var form = $(element);
    var modal = $('#modal-save-customer-number');

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': form.find('[name="_token"]').val()}});

    form.off('submit').on('submit', function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            url: this.action,
            data: $(this).serialize(),
            success: function (response) {

                modal.modal('toggle');

                printResponse(response);
            },
            error: function (data) {
                listFormError(data, form.find('.error-list'))
            },
        })
    });

    modal.on('hidden.bs.modal', function () {
        resetForm(form);
    });
};